import ApiService from '../../api/ApiService'
import { useLayoutEffect, useRef, useState, useEffect } from 'react'
import '../../css/festivalschedule.scss'
import ScrollTrigger from 'gsap/ScrollTrigger'


const JanmashtamiSchedule = () => {


    const [programSchedule, setProgramSchedule] = useState(null);
    // console.log("homepagebannerdata", programSchedule);

    const fetchHomepageBannerData = async () => {
        try {
            let res = await ApiService.fetchHomepageBannerData()
            console.log("home", res);



            if (res?.programSchedules?.length > 0) {
                setProgramSchedule(res.programSchedules[0]);
            }
        } catch (error) {
            console.log(error);

        }
    };

    useEffect(() => {
        fetchHomepageBannerData();
    }, []);
    if (!programSchedule) return null;
    return (
        <section className="p-0">
            <div className="container">
                <div className="schedule">
                    <div className="info">
                        <h7>{programSchedule?.invitationText}</h7>
                        <h2>{programSchedule?.mainTitle}</h2>
                        <div className="box1">
                            <p className="p1">{programSchedule?.darshanInfo}</p>
                        </div>
                        <div>
                            <div className="venue">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="#FFB000"
                                    viewBox="0 0 16 16"
                                    style={{ marginRight: "5px" }}
                                >
                                    <path d="M8 0a5 5 0 0 0-5 5c0 3.25 5 11 5 11s5-7.75 5-11a5 5 0 0 0-5-5zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" />
                                </svg>
                                <p className="p2" style={{ margin: 0 }}>Venue</p>
                            </div>
                            <div className="address">
                                <a
                                    href="https://www.google.com/maps/place/ISKCON+Attapur/@19.2792965,73.0647854,783m/data=!3m2!1e3!4b1!4m6!3m5!1s0x3be7bd98e9789d5f:0x3a60e0edeab7fa5c!8m2!3d19.2792965!4d73.0647854!16s%2Fg%2F11gjt6fd5b?entry=ttu"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                >
                                    <p className="p3">ISKCON BHIWANDI</p>
                                    <p className="p3">Bunglow No. 82, Mansarovar Gardens, Plot No. 24,</p>
                                    <p className="p3">Opp. Devi Lake, Mansarovar, Padma Nagar,</p>
                                    <p className="p3">Attapur, Maharashtra 421305</p>
                                </a>
                            </div>


                        </div>
                        <div>
                            <div className="venue">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="#FFB000"
                                    viewBox="0 0 24 24"
                                    style={{ marginRight: "5px" }}
                                >
                                    <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 
             10 10 10-4.486 10-10S17.514 2 12 2zm7.9 
             9h-3.09c-.154-2.28-.99-4.51-2.31-6.25A8.03 
             8.03 0 0 1 19.9 11zM12 4c1.33 1.42 2.22 3.67 
             2.4 6H9.6C9.78 7.67 10.67 5.42 12 4zM7.5 
             4.75C6.19 6.49 5.35 8.72 5.19 11H2.1A8.03 
             8.03 0 0 1 7.5 4.75zM2.1 13h3.09c.16 
             2.28.99 4.51 2.31 6.25A8.03 8.03 0 0 
             1 2.1 13zM12 20c-1.33-1.42-2.22-3.67-2.4-6h4.8c-.18 
             2.33-1.07 4.58-2.4 6zm4.5-.75c1.31-1.74 2.15-3.97 
             2.31-6.25h3.09a8.03 8.03 0 0 1-5.4 6.25zM8.5 
             8h7a9.93 9.93 0 0 0-7 0zm0 8h7a9.93 9.93 0 0 1-7 0z" />
                                </svg>
                                <p className="p2" style={{ margin: 0 }}>{programSchedule?.videoTitle}</p></div>
                            <div className="address">
                                <p className="p3">
                                    <a
                                        href={programSchedule?.videoLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {programSchedule?.videoLink}
                                    </a>
                                </p>
                            </div>

                        </div>
                        <h3>{programSchedule?.welcomeText}</h3>
                        <p className="p3">{programSchedule?.footerText}</p>
                    </div>

                    <div className="timing">
                        <h2>Program Schedule</h2>
                        {programSchedule?.programs?.map((item) => (
                            <div className="schedule-row" key={item._id}>
                                <div className="time-container">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" style={{ marginRight: "5px" }}>
                                        <circle cx="4" cy="4" r="4" fill="#FFC84F" />
                                    </svg>
                                    <p className="time">{item.time}</p>
                                </div>
                                <div className="arrow-container">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                                        <path d="M1 8h12M9 4l4 4-4 4" stroke="#FFC84F" strokeWidth="2" fill="none" />
                                    </svg>
                                </div>
                                <p className="p4">{item.name}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section >
    );
}

export default JanmashtamiSchedule